import { Link } from "wouter";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTokenSavings } from "@/hooks/useTokenSavings";
import { formatCompactTokens } from "@shared/tokenSavings";

export function McpTokenSavingsCard() {
  const { data } = useTokenSavings("all");
  const week = useTokenSavings("7d");
  const mcpAll = data?.bySurface.find((row) => row.surface === "mcp");
  const mcpWeek = week.data?.bySurface.find((row) => row.surface === "mcp");

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">MCP retrieval savings</CardTitle>
      </CardHeader>
      <CardContent className="text-sm space-y-2">
        <p>
          All time: {formatCompactTokens(mcpAll?.tokensSaved ?? 0)} tokens packed away
        </p>
        <p>
          Last 7 days: {formatCompactTokens(mcpWeek?.tokensSaved ?? 0)}
        </p>
        <Link href="/token-savings" className="text-primary hover:underline">
          See all sections
        </Link>
      </CardContent>
    </Card>
  );
}
